import { Link } from "react-router-dom";

export const NavLogo = () => {
  return (
    <div className="logo">
      <Link to="/">
        <svg
          id="Capa_1"
          enableBackground="new 0 0 512 512"
          height="45"
          viewBox="-40 -40 1300 592" 
          width="100"
          xmlns="http://www.w3.org/2000/svg"
          style={{background: 'transparent'}}
          className="text-black dark:text-white transition-colors duration-200"
        >
          <filter id="shadow">
            <feDropShadow 
              dx="0" 
              dy="0" 
              stdDeviation="3"
              floodColor="currentColor"
              floodOpacity="0.3"
            />
          </filter>
          <g id="N_2_" filter="url(#shadow)">
            <path
              d="m465.5 0v512h-118.02l-182.36-278.82v278.82h-118.62v-512h115.96l185.21 285.96v-285.96z"
              fill="transparent"
              stroke="currentColor"
              strokeWidth="12"
              strokeLinejoin="round"
              strokeLinecap="round"
              rx="32"
              ry="32"
              className="transition-all duration-300 hover:stroke-primary"
            />
          </g>
        </svg>
      </Link>
    </div>
  );
}; 